import script from "./ManageStreamBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageStreamBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageStreamBox.vue?vue&type=style&index=0&id=354b6d64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354b6d64"]])

export default __exports__